const STATICPATH = '/static/'

export default {
  STATICPATH: STATICPATH,
}



// WEBPACK FOOTER //
// ./src/constant/index.js